import React from 'react';
import CardsPage from './CardsPage';
import countData from '../Data/countData';

function Ginti() {
    return <CardsPage data={countData} />;
}

export default Ginti;
